import styled from 'styled-components';
import { Button, ButtonProps } from '@m/alchemy-ui/Button';

import { Reward } from 'settings/Settings.types';

const RewardImg = styled.img`
  filter: brightness(0) saturate(100%) invert(44%) sepia(45%) saturate(1050%) hue-rotate(176deg) brightness(88%) contrast(93%);
  height: 48px;
  margin-bottom: 8px;
`;

const RewardIconButton = styled(Button).attrs({ type: 'button' })`
  border-radius: 8px;
  height: 96px;
  padding: 0 8px;
  width: 96px;

  & > div {
    flex-direction: column;

    p {
      white-space: pre-wrap;
    }
  }

  &[aria-pressed="true"] {
    ${RewardImg} {
      filter: brightness(0) invert(1);
    }
  }
`;

export function RewardButton({
  reward,
  className,
  isSelected,
  onClick = () => {},
}: RewardButtonProps) {
  const btnPriority: ButtonProps['priority'] = isSelected
    ? 'primary'
    : 'secondary';
  const btnPalette: ButtonProps['palette'] = isSelected
    ? 'interactiveConstructive'
    : 'expressiveInformative';

  return (
    <RewardIconButton
      onClick={() => onClick(reward)}
      className={className}
      palette={btnPalette}
      priority={btnPriority}
      aria-pressed={isSelected}
    >
      <RewardImg src={reward.imageUrl} />
      <p>{reward.caption}</p>
    </RewardIconButton>
  );
}

interface RewardButtonProps {
  reward: Reward;
  className?: string;
  isSelected: boolean;
  onClick?: (reward: Reward) => void;
}
